<template>
    <StepDescription :stepDescription="'Evite senhas óbvias como nome próprio ou números em sequência.'"/>
    <FormKit
        type="form"
        :value="{
            password: password,
            password_confirm:password_confirm,
        }"
        @submit="confirmData"

    >
        <FormKit
            type="password"
            name="password"
            id="senha"
            label="Senha"
            validation="required"
            :validation-messages="{
            required: 'Sua senha é obrigatória',
            }"
            @input="validationsComponent"
            v-model="password"
        />
        <FormKit
            type="password"
            name="password_confirm"
            label="Repetir senha"
            id="repetir_senha"
            validation="required|confirm"
            :validation-messages="{
            required: 'Repetir a senha é obrigatório',
            confirm: 'A senha está diferente da senha acima'
            }"
            v-model="password_confirm"
        />

        <template #submit>
            <FooterButton>
            </FooterButton>
        </template>
    </FormKit>
    <CardPasswordSecurity
      :strength="strength"
      :acceptable="acceptable"
      :violations="violations"
    />
</template>
<script>
import CardPasswordSecurity from '../../components/CardPasswordSecurity.vue'
import StepDescription from '../../components/StepDescription.vue'
import FooterButton from '../../components/FooterButton.vue'
import zxcvbn from 'zxcvbn';
import { useRouter } from 'vue-router'
import { useStore } from '../../../stores/cadastro.js'
import { ref, onMounted } from 'vue'

export default {
    components: {
        CardPasswordSecurity,
        StepDescription,
        FooterButton
    },

    data() {
      return {
        password: '',
        password_confirm: '',
      }
    },

    setup() {
        const router = useRouter();
        const store = useStore();
        const password = ref(store.getRegistrationData.password || '');
        const password_confirm = ref(store.getRegistrationData.password_confirm || '');

        const violations = ref({});
        const acceptable = ref(false);
        const strength = ref(0);

        const validationsComponent = (currentPassword) => {

            const hasSpecialChar = /-/.test(currentPassword) || /[!@#$-%^&*(),.?":{}|<>]/.test(currentPassword);
            const hasNumber = /\d/.test(currentPassword);

            const _violations = {};
            let rulesValidated = 0;

            if (currentPassword.length >= 8) {
                rulesValidated++;
            } else {
                _violations['length'] = true;
            }

            if (hasNumber) {
                rulesValidated++;
            } else {
                _violations['numbers'] = true;
            }

            if (hasSpecialChar) {
                rulesValidated++;
            } else {
                _violations['specialChars'] = true;
            }

            const strengthResult = zxcvbn(currentPassword);

            violations.value = _violations;
            strength.value = Math.min(4, strengthResult.score) + rulesValidated;
            acceptable.value = (rulesValidated === 3 && strengthResult.score >= 2);
        };

        const confirmData = async (formData) => {
            if (!acceptable.value) {
                return;
            }
            await store.updatePreRegistrationData(formData);
            router.push({ name: 'TypeVehicle' });
        };

        onMounted(() => {
            validationsComponent(password.value);
        });

        return {
            confirmData,
            password,
            password_confirm,
            validationsComponent,
            violations,
            acceptable,
            strength,
        };
    }
}
</script>
